import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  public isSafari(): boolean {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public haveObjectsChanged(a: any, b: any): boolean {
    const keys = Object.keys(a ?? {});
    if (keys.length !== Object.keys(b ?? {}).length) return false;

    return keys.every((key) => {
      const av = a[key],
        bv = b[key];
      return typeof av === 'object' ? JSON.stringify(av) === JSON.stringify(bv) : av === bv;
    });
  }
}
